export enum HintPosition {
    relativeToElement,
    relativeToCursor,
}
